<!-- Browse by port -->
<div *ngIf="browseType=='port'">
  <div class="card">
    <div class="card-body p-0 border-radius-05" data-parent='#example'>
      <div class="d-flex p-1 pl-4 stripe" [ngStyle]="{'background-color':productInfo.headerColor}">
        <!-- <div class="strong text-white">{{productInfo.shortDescription}}</div> -->
        <!-- <div class="strong text-white">{{productInfo.baseProductCode}}</div> -->
      </div>
      <div class="card-title">
        <div class='d-flex justify-content-between mt-2 ml-4'>
          <h4 class="strong">
            {{productInfo.name}}
            <span class="text-secondary ml-2">{{port.name}}</span>
          </h4>
          <div class='d-flex'>
            <div class="mr-3">
              <span class="text-secondary small">{{ 'home.quote.Vesselname' | cxTranslate }}</span>
              <div class="small bold text-secondary" title="{{productInfo.vesselName | uppercase}}"> {{productInfo.vesselName | uppercase}}</div>
            </div>
            <div class="mr-5 pr-4">
              <span class="text-secondary small">{{ 'home.productHeader.Voyage' | cxTranslate }}</span>
              <div class="small bold text-secondary"> {{productInfo.voyageId | uppercase}}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="productInfo.features != undefined">
        <div class="row quality-alignment" *ngIf="productInfo.features.entry != undefined">
          <div *ngFor='let a of productInfo.features.entry' class=" col-md-4">
            <div class="small text-secondary pr-3 visible-xs mr-5 d-flex justify-content-between quality-align-width"
            *ngIf="(a.key !== 'size lowest') && (a.key !== 'size max') && (a.key !== 'qualityId') && (a.key !== 'other Metal (%)') ">
              <div>{{a.key}}</div>
              <div class='semibold'>{{a.value}}%</div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb-3">
        <div class="mt-4 col-3 mr-5 text-nowrap">
          <!-- <a class="text-primary text-decoration-underline ml-4">{{ 'home.productHeader.Terms&Conditions' | cxTranslate
            }}</a> -->

        </div>
        <div class="choose col-md-2 text-right">
          <span class=""></span>
        </div>
        <div class="col-md-2 p-0 text-secondary">
          <div class="data-content1 text-secondary small pb-1">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}
          </div>
          <div>
            <!-- <span
              class=" currency-icon position-absolute ml-2 mt-2">{{productInfo.price!=undefined?productInfo.price.formattedValue[0]:''}}&nbsp;</span> -->
            <span class="fs-10 currency-icon position-absolute">{{'home.productHeader.rmb' | cxTranslate}}&nbsp;</span>
            <input [(ngModel)]="productPrice" (keypress)="checkPriceValidation($event);validateDecimalPointPrice($event)"
              class="input-field pl-5 bold p-3 border bg-white" appTwoDigitDecimaNumber onkeypress="return event.charCode != 45" preventCutCopyPaste>
              <div class="wrapper mobicon">
                <div class="icon">
                  <div class="tooltip text-white">
                    <div class="tooltip-value">{{ 'home.productHeader.tooltipValue' | cxTranslate }}</div>
                  </div>
                  <span data-toggle="tooltip" data-placement="right" class="badge bg-light badge-pill ques-mark">?</span>
                </div>
              </div>
          </div>
          <div class="text-right text-secondary fs-10 mr-3">{{ 'home.productHeader.incOfTaxes' | cxTranslate }}</div>
        </div>
        <div class="col-md-2 p-0 text-secondary">
          <div class="data-content1 text-secondary small pb-1">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}
          </div>
          <div> <input  numeric allowPositiveAndNegativeNumbers  type="text" [maxlength]="maxLen" [(ngModel)]="quantitySelected"  class="input-field space bold p-3 border bg-white"  required >

            <!-- <select *ngIf="!showquantity" [(ngModel)]="quantitySelected" name="" id=""
              class="roud d-inline-flex p-2 bold text-black input-field">
              <option value="{{p}}" *ngFor="let p of quantityRangeArrya">{{p}}</option>
            </select> -->
          </div>
            <div><input *ngIf="showquantity" numeric allowPositiveAndNegativeNumbers type="text" [maxlength]="maxLen" [(ngModel)]="actualQuantitySelected"  class="input-field space bold p-3 border bg-white"  required >
              <!-- <select *ngIf="showquantity" [(ngModel)]="actualQuantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
              <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
            </select> -->
          </div>
          <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font fs-10">{{ 'home.productHeader.qtyRequiredCheck' | cxTranslate }}</p>
          <p *ngIf="qtyValidErr" class="text-danger my-1 err-font ">{{ 'home.productHeader.qtyValidCheck' | cxTranslate }} {{this.productInfo.minimumQty+'-'+this.productInfo.maximumQty}}</p>
  
        </div>
        <div class="col-md-2 pr-0 ml-2">
          <button [disabled]="isPlaceBidDisabled" class="btn btn-block btn-primary mt-4" (click)="openModal(content1,productInfo)">{{
            'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Browse by product-->
<div *ngIf="browseType=='productType'">
  <div class="card">
    <div class="p-0 card-body border-radius-05">
      <div class="d-flex p-1 pl-4 stripe" [ngStyle]="{'background-color':productInfo.headerColor}">
        <!-- <div class="strong text-white">{{productInfo.shortDescription}}</div> -->
        <!-- <div class="strong text-white">{{productInfo.baseProductCode}}</div> -->
      </div>
      <div class="card-title">
        <div class='d-flex justify-content-between mt-2 ml-4'>
          <h4 class="strong">
            {{productInfo.name}}
            <span class="text-secondary ml-2">{{productInfo.ports.length !==0?productInfo.ports[0].name?productInfo.ports[0].name:'':''}}</span>
          </h4>
          <div class='d-flex'>
            <div class="mr-3">
              <span class="text-secondary small">{{ 'home.quote.Vesselname' | cxTranslate }}</span>
              <div class="small bold text-secondary" title="{{productInfo.vesselName | uppercase}}"> {{productInfo.vesselName | uppercase}}</div>
            </div>  
            <div class="mr-5 pr-4">
              <span class="text-secondary small">{{ 'home.productHeader.Voyage' | cxTranslate }}</span>
              <div class="small bold text-secondary"> {{productInfo.voyageId | uppercase}}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="productInfo.features != undefined">
        <div class="row quality-alignment" *ngIf="productInfo.features.entry != undefined">
          <div *ngFor='let a of productInfo.features.entry' class=" col-md-4">
            <div class="small text-secondary pr-3 visible-xs mr-5 d-flex justify-content-between quality-align-width"
            *ngIf="(a.key !== 'size lowest') && (a.key !== 'size max') && (a.key !== 'qualityId') && (a.key !== 'other Metal (%)') ">
              <div>{{a.key}}</div>
              <div class='semibold'>{{a.value}}%</div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb-3">
        <div class="mt-4 col-3 mr-5">
          <!-- <a class="text-primary text-decoration-underline ml-4">{{ 'home.productHeader.Terms&Conditions' | cxTranslate
            }}</a> -->
        </div>
        <div class="mt-4 col-md-2 text-right">
          <span class=""></span>
        </div>
        <div class="col-md-2 p-0 text-secondary">
          <div>{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}</div>
          <div>
            <!-- <span
              class=" currency-icon position-absolute ml-2 mt-2">{{productInfo.price!=undefined?productInfo.price.formattedValue[0]:''}}&nbsp;</span> -->
              <span class="fs-10 currency-icon position-absolute">{{'home.productHeader.rmb' | cxTranslate}}&nbsp;</span>
            <input [(ngModel)]="productPrice" (keypress)="checkPriceValidation($event)"
              class="input-field pl-5 bold p-3 border bg-white" appTwoDigitDecimaNumber onkeypress="return event.charCode != 45" preventCutCopyPaste>
              <div class="wrapper mobicon">
                <div class="icon">
                  <div class="tooltip text-white">
                    <div class="tooltip-value">{{ 'home.productHeader.tooltipValue' | cxTranslate }}</div>
                  </div>
                  <span data-toggle="tooltip" data-placement="right" class="badge bg-light badge-pill ques-mark">?</span>
                </div>
              </div>
          </div>
          <div class="text-right text-secondary fs-10 mr-3">{{ 'home.productHeader.incOfTaxes' | cxTranslate }}</div>
        </div>
        <div class="col-md-2 p-0 text-secondary">
          <div>{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
          <div> <input  numeric allowPositiveAndNegativeNumbers  type="text" [maxlength]="maxLen" [(ngModel)]="quantitySelected"  class="input-field space bold p-3 border bg-white"  required >

           
          </div>
            <!-- <div><select *ngIf="showquantity" [(ngModel)]="actualQuantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
              <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
            </select></div> -->

        </div>
        <div class="col-md-2 pr-0 ml-2">
          <button [disabled]="isPlaceBidDisabled" class="btn btn-block btn-primary mt-4" (click)="openModal(content1,productInfo)"
            (click)="modal = true">{{
            'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- browse by all -->
<div *ngIf="browseType=='browseAll' || browseType=='quotesDetails'">
  <div class="card">
    <div class="card-body p-0 border-radius-05" data-parent='#example'>
      <div class="d-flex p-1 pl-4 stripe" [ngStyle]="{'background-color':productInfo.headerColor}">
        <!-- <div class="strong text-white">{{productInfo.shortDescription}}</div> -->
        <!-- <div class="strong text-white">{{productInfo.baseProductCode}}</div> -->
      </div>
      <div class="card-title">
        <div class='d-flex justify-content-between mt-2 ml-4'>
          <h4 class="strong">
            {{productInfo.name}}
            <span class="text-secondary ml-2">{{productInfo.ports.length !==0?productInfo.ports[0].name?productInfo.ports[0].name:'':''}}</span>
          </h4>
          <div class='d-flex'>
            <div class="mr-3">
              <span class="text-secondary small">{{ 'home.quote.Vesselname' | cxTranslate }}</span>
              <div class="small bold text-secondary" title="{{productInfo.vesselName | uppercase}}"> {{productInfo.vesselName | uppercase}}</div>
            </div>
            <div class="mr-5 pr-4">
              <span class="text-secondary small">{{ 'home.productHeader.Voyage' | cxTranslate }}</span>
              <div class="small bold text-secondary"> {{productInfo.voyageId | uppercase}}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="productInfo.features != undefined">
        <div class="row quality-alignment" *ngIf="productInfo.features.entry != undefined">
          <div *ngFor='let a of productInfo.features.entry' class=" col-md-4">
            <div class="small text-secondary pr-3 visible-xs mr-5 d-flex justify-content-between quality-align-width"
            *ngIf="(a.key !== 'size lowest') && (a.key !== 'size max') && (a.key !== 'qualityId') && (a.key !== 'other Metal (%)') ">
              <div>{{a.key}}</div>
              <div class='semibold'>{{a.value}}%</div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb-3">
        <div class="mt-4 col-3 col-md-2 col-lg-2 mr-5 text-nowrap">
          <!-- <a class="text-primary text-decoration-underline ml-4">{{ 'home.productHeader.Terms&Conditions' | cxTranslate
            }}</a> -->
        </div>
        <div class="choose col-md-2 col-lg-2 text-right mr-5">
          <span class=""></span>
        </div>
        <div class="col-md-3 col-lg-2 p-0 text-secondary ml-5">
          <div class="data-content1 text-secondary small">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}</div>
          <div>
            <!-- <span
              class=" currency-icon position-absolute ml-2 mt-2">{{productInfo.price!=undefined?productInfo.price.formattedValue[0]:''}}&nbsp;</span> -->
              <span class="fs-10 currency-icon position-absolute">{{'home.productHeader.rmb' | cxTranslate}}&nbsp;</span>
            <input [(ngModel)]="productPrice" (keypress)="checkPriceValidation($event)"
              class="input-field pl-5 bold p-3 border bg-white" appTwoDigitDecimaNumber onkeypress="return event.charCode != 45" preventCutCopyPaste>
              <div class="wrapper mobicon">
                <div class="icon">
                  <div class="tooltip text-white">
                    <div class="tooltip-value">{{ 'home.productHeader.tooltipValue' | cxTranslate }}</div>
                  </div>
                  <span data-toggle="tooltip" data-placement="right" class="badge bg-light badge-pill ques-mark">?</span>
                </div>
              </div>
          </div>
          <div class="text-right text-secondary fs-10 mr-3">{{ 'home.productHeader.incOfTaxes' | cxTranslate }}</div>
        </div>
        <div class="col-md-3 col-lg-2 p-0 text-secondary">
          <div class="data-content1 text-secondary small">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
          <div>
            <input  numeric allowPositiveAndNegativeNumbers  type="text" [maxlength]="maxLen" [(ngModel)]="quantitySelected"  class="input-field space bold p-3 border bg-white"  required >
            <!-- <select *ngIf="!showquantity" [(ngModel)]="quantitySelected" name="" id=""
              class="roud d-inline-flex text-black p-2 bold input-field">
              <option value="{{p}}" *ngFor="let p of quantityRangeArrya">{{p}}</option>
            </select> -->
          </div>
            <!-- <div><select *ngIf="showquantity" [(ngModel)]="actualQuantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
              <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
            </select></div> -->
             <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font fs-10">{{ 'home.productHeader.qtyRequiredCheck' | cxTranslate }}</p>
          <p *ngIf="qtyValidErr" class="text-danger my-1 err-font ">{{ 'home.productHeader.qtyValidCheck' | cxTranslate }} {{this.productInfo.minimumQty+'-'+this.productInfo.maximumQty}}</p>
  
  
        </div>
        <div class="col-md-3 col-lg-2" *ngIf="browseType!=='quotesDetails'">
          <button [disabled]="isPlaceBidDisabled" class="btn btn-block btn-primary mt-4" (click)="openModal(content1,productInfo)">{{
            'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- counter offer resusable modal component -->
<app-confirm-bid-modal #modalData [modalConfig]="modalConfig">
  <!--  body of the modal  -->
</app-confirm-bid-modal>
